import { escapeRegExp as esc, getProp } from './parser/tools';
const crx = (s, f = 'i') => new RegExp(s, f);

const relOps = {
  '>=': (a, b) => parseFloat(a) >= b,
  '<=': (a, b) => parseFloat(a) <= b,
  '<': (a, b) => parseFloat(a) < b,
  '>': (a, b) => parseFloat(a) > b,
};

export function makeQuery(q) {
  const qa = []; let m;
  const rx = /(\.|#|\[|)(\b[^.#\]]+\b)/g;
  /* eslint-disable-next-line no-cond-assign */
  while (m = rx.exec(q)) {
    const m2 = m[2];
    const m2r = crx('\\b' + m2 + '\\b');
    if (m[1] === '') qa.push(t => m2r.test(t));
    if (m[1] === '#') qa.push((t, o) => m2r.test(o.id));
    if (m[1] === '.') qa.push((t, o) => m2r.test(o.class));
    if (m[1] === '[') {
      const [attr, op, ...arrval] = m2.split(/([|*~$!^]?=|[<>]=?)/);
      if (!op) {
        qa.push((t, o) => attr in o);
        continue;
      }
      const val = arrval.join('').replace(/^['"]|['"]$/, '');
      if (op === '=') {
        // Attribute Equals Selector
        const rxa = crx('^' + esc(val) + '$');
        qa.push((t, o) => rxa.test(o[attr]));
      } else if (op === '!=') {
        // Attribute Not Equal Selector
        const rxa = crx('^' + esc(val) + '$');
        qa.push((t, o) => rxa.test(!o[attr]));
      } else if (op === '^=') {
        // Attribute Starts With Selector
        const rxa = crx('^' + esc(val));
        qa.push((t, o) => rxa.test(o[attr]));
      } else if (op === '|=') {
        // Attribute Contains Prefix Selector
        const rxa = crx('^' + esc(val) + '(-|$)');
        qa.push((t, o) => rxa.test(o[attr]));
      } else if (op === '*=') {
        // Attribute Contains Selector
        const rxa = crx(esc(val));
        qa.push((t, o) => rxa.test(o[attr]));
      } else if (op === '*=') {
        // Attribute Contains Word Selector
        const rxa = crx('\\b' + esc(val) + '\\b');
        qa.push((t, o) => rxa.test(o[attr]));
      } else if (op === '$=') {
        // Attribute Ends With Selector
        const rxa = crx(esc(val) + '$');
        qa.push((t, o) => rxa.test(o[attr]));
      } else {
        const numval = parseFloat(val);
        if (!numval) continue;
        if (op in relOps) qa.push((t, o) => relOps[op](o[attr], numval));
      }
    }
  }
  return qa;
}

export function testQuery(n, qry) {
  return qry.reduce((a, q) => a && q(n.tag, { tagtype: n.type, ...n.attrs }), true);
}

export function query(dom, qry, all = false) {
  if (!dom) return;
  if (!Array.isArray(qry)) qry = makeQuery(qry);
  const queue = [...dom.map((x, i) => `${i}`)];
  const retval = [];
  while (queue.length) {
    const k = queue.shift();
    const o = getProp(dom, k);
    if (typeof o === 'string') continue;
    if (testQuery(o, qry)) {
      if (all === -9) return k;
      if (all === false) return o;
      retval.push(o);
    }
    if (o.children) {
      queue.push(...o.children.map((x, i) => `${k}.children.${i}`));
    }
  }
  // console.log('queried elements:', i);
  if (all === -9) return -1;
  return all ? retval : retval[0];
}

export function textContents(node) {
  if (!node) return '';
  const retval = [];
  const queue = [...node.children];
  while (queue.length) {
    const o = queue.shift();
    if (typeof o !== 'object') retval.push(o);
    else queue.push(...o.children);
  }
  return retval.join('').trim();
}
